import { Menu } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { Sidebar } from "./Sidebar"
import { useState } from "react"
interface HeaderProps {
  onCreateCard: () => void
}

export function Header({ onCreateCard }: HeaderProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header id="headerContainer" className="sticky top-0 z-50 w-full h-14 bg-background">
      <div id="headerContent" className="h-full flex items-center justify-between px-4">
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon">
              <Menu className="h-6 w-6 text-muted-foreground md:hidden" />
            </Button>
          </SheetTrigger>
          <SheetContent 
            side="left" 
            className="p-0 bg-background"
          >
            <Sidebar 
              onCreateCard={onCreateCard} 
              onClose={() => setIsOpen(false)}
            />
          </SheetContent>
        </Sheet>

        <h1 className="text-2xl font-bold font-instrument text-logo/90">Dekk</h1>

        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => window.location.reload()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-6 w-6 text-muted-foreground"
          >
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
        </Button>
      </div>
    </header>
  )
} 